(function (Drupal) {
  Drupal.behaviors.titles_menu = {
    attach(context) {
      const titles = []
      const titlesText = once('titles', '.individual-program h3, .titles-menu h3, .ckeditor-accordion-toggler', context);
      titlesText.forEach(item => {
        let text = item.querySelector('button') ? item.querySelector('button').innerHTML : item.innerHTML
        titles.push(text)

        item.id = `scroll-${titles.length - 1}`
      })

      const titlesWrapper = document.querySelector('.sidebar__content__headers')
      titles.forEach((item, index) => {
        titlesWrapper.innerHTML += `<a href="#scroll-${index}"">${item}</a>`
      })

      once('show-more', '.individual-program__content__header__wrapper', context).forEach(item => {

      const headerTitles = document.querySelectorAll('.individual-program__content__header__wrapper');
      if (headerTitles.length) {
        headerTitles.forEach((item) => {
          const height = item.querySelector('p').offsetHeight;
          const maxHeight = item.offsetHeight;

          if (height > maxHeight) {
            const span = document.createElement('button');
            span.className = 'show-more';
            span.innerHTML = '<span class="material-icons-outlined">expand_more</span>';
            item.appendChild(span);
            item.parentNode.insertBefore(span, item.nextSibling);

            span.addEventListener('click', () => {
              item.classList.toggle('expanded');
            });
          }
        });
      }
      })


    },
  };
})(Drupal);
